import { NgModule } from '@angular/core';
import { ClearanceItemTagComponent } from '.';
import { ClearanceItemBulkModule } from './bulk-action/clearance-item-bulk.module';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterializeModule } from 'angular2-materialize';
import { CommonModule } from '@angular/common';
import { ClearanceItemAssetManagerComponent } from './asset-management/clearance-item-asset-manager.component';
import { AssetManagerModule } from '../shared/asset-manager.module';

@NgModule({
    imports:[
        ReactiveFormsModule,
        MaterializeModule,
        CommonModule,
        // AssetManagerModule
    ],
    declarations:[
        ClearanceItemTagComponent
    ],
    exports:[
        ClearanceItemTagComponent,
        // AssetManagerModule
    ]
})
export class ClearanceItemCommonModule{}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/clearance-item/clearance-item-common.module.ts